// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SeenList__container-d8bc60 {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  margin-bottom: 10px;
}

.SeenList__placeholders-d4af06 {
  padding: 8px 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ReactionsDetailedPopup/UserList/SeenList/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n  margin-bottom: 10px;\n}\n\n.placeholders {\n  padding: 8px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SeenList__container-d8bc60`,
	"placeholders": `SeenList__placeholders-d4af06`
};
module.exports = ___CSS_LOADER_EXPORT___;
